import { aseDownloadHandTalkAppAnimationCodes } from './ase';
import { bzsDownloadHandTalkAppAnimationCodes } from './bzs';

export const appInfoAnimations = {
  pt: bzsDownloadHandTalkAppAnimationCodes,
  en: aseDownloadHandTalkAppAnimationCodes,
};
